module.exports = __webpack_public_path__ + "img/stonks.caa0a394.svg";